import types from '../mutation-types';
import CampaignSegmentsAPI from '../../api/campaignSegments';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getSegments: _state => _state.records,
  getUIFlags: _state => _state.uiFlags,
};

export const actions = {
  fetch: async ({ commit }) => {
    commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isFetching: true });
    try {
      const { data } = await CampaignSegmentsAPI.get();
      commit(types.SET_CAMPAIGN_SEGMENTS, data);
    } catch {
      // Ignore
    } finally {
      commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isFetching: false });
    }
  },

  create: async ({ commit }, segmentObj) => {
    commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isCreating: true });
    try {
      const { data } = await CampaignSegmentsAPI.create(segmentObj);
      commit(types.ADD_CAMPAIGN_SEGMENT, data);
      return data;
    } finally {
      commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isCreating: false });
    }
  },

  update: async ({ commit }, { id, ...updateObj }) => {
    commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isUpdating: true });
    try {
      const { data } = await CampaignSegmentsAPI.update(id, updateObj);
      commit(types.EDIT_CAMPAIGN_SEGMENT, data);
      return data;
    } finally {
      commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isUpdating: false });
    }
  },

  delete: async ({ commit }, id) => {
    commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isDeleting: true });
    try {
      await CampaignSegmentsAPI.delete(id);
      commit(types.DELETE_CAMPAIGN_SEGMENT, id);
    } finally {
      commit(types.SET_CAMPAIGN_SEGMENT_UI_FLAG, { isDeleting: false });
    }
  },
};

export const mutations = {
  [types.SET_CAMPAIGN_SEGMENT_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [types.SET_CAMPAIGN_SEGMENTS](_state, data) {
    _state.records = data;
  },
  [types.ADD_CAMPAIGN_SEGMENT](_state, data) {
    _state.records.unshift(data);
  },
  [types.EDIT_CAMPAIGN_SEGMENT](_state, data) {
    const index = _state.records.findIndex(r => r.id === data.id);
    if (index !== -1) {
      _state.records.splice(index, 1, data);
    }
  },
  [types.DELETE_CAMPAIGN_SEGMENT](_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations,
};
